import { render } from "./AppUserGuidePage.vue?vue&type=template&id=916d4a7e&scoped=true"
import script from "./AppUserGuidePage.vue?vue&type=script&lang=js"
export * from "./AppUserGuidePage.vue?vue&type=script&lang=js"

import "./AppUserGuidePage.vue?vue&type=style&index=0&id=916d4a7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916d4a7e"]])

export default __exports__